module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_2.e4088517.png";